module.exports = __webpack_public_path__ + "static/img/Mars.675e190.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/planet/Mars.svg
// module id = 1411
// module chunks = 0